import { useParams } from 'react-router-dom'
import { useStateValue } from 'providers'
import { ChatPanel } from './components/panel'
import { RequireUsername } from './components/require-username'
import { useLocationChat } from './use-location-chat'

// Chat for a regular user viewing a place's page (`/places/:id`).
export const UserChat = () => {
  const [
    {
      session: { user }
    }
  ] = useStateValue()
  const { id } = useParams()
  const { comments, send } = useLocationChat(`/locations/${id}`)

  return (
    <RequireUsername user={user}>
      <ChatPanel comments={comments} currentUserId={user.id} onSend={send} />
    </RequireUsername>
  )
}
